import React from 'react'

const IconBreadcrumbChevron = ({
  className,
  strokeWidth = '1'
}: {
  className: string
  strokeWidth: string
}): JSX.Element => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.61715 12.8536C6.42189 12.6583 6.42189 12.3417 6.61715 12.1464L10.2636 8.5L6.61715 4.85355C6.42189 4.65829 6.42189 4.34171 6.61715 4.14645C6.81241 3.95118 7.12899 3.95118 7.32426 4.14645L11.3243 8.14645C11.5195 8.34171 11.5195 8.65829 11.3243 8.85355L7.32426 12.8536C7.12899 13.0488 6.81241 13.0488 6.61715 12.8536Z"
        fill="currentColor"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}

export default IconBreadcrumbChevron
